import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import ENDPOINT from "./data/ENDPOINT";
import SecurityHeaders from "./data/SecurityHeaders";
import { Link, useParams } from "react-router-dom"; // fixed import (removed /cjs/...)

const SingleBook = () => {
    const params = useParams()
 

  const [response, setResponse] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  const GetBooks = async () => {
    try {
        const data = new FormData();
      const res = await axios.post(
        `${ENDPOINT}get-books.php`,
        data,
        SecurityHeaders
      );
      if (res.data.status === "success") {
            setResponse(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching books:", error);
           }
  };

  useEffect(() => {
    GetBooks();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

 return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f8fafc",
        fontFamily: "system-ui, -apple-system, sans-serif",
        color: "#0f172a",
      }}
    >
      <style>{`
        .hover-scale:hover {
          transform: scale(1.05);
        }
        .transition-300 {
          transition: all 0.3s ease;
        }
      `}</style>

      <div className="container-fluid px-4 px-lg-5 py-5">
        <h2 className="text-center mb-5 fw-bold">Available Books & Modules</h2>

        <div className="row g-4 justify-content-center">
          {response ? (
            response.map((item, index) => (
              <div key={index} className="col-md-6 col-lg-4">
                <div
                  className="p-4 rounded-4 border bg-white shadow-sm transition-300 hover-scale h-100 d-flex flex-column"
                  style={{
                    backgroundColor: "rgba(255,255,255,0.9)",
                    borderColor: "#e2e8f0",
                  }}
                >
                  {/* Image Container */}
                  <div
                    className="mb-4 bg-light rounded-3 shadow-sm d-flex align-items-center justify-content-center overflow-hidden"
                    style={{
                      height: "220px",
                      backgroundColor: "#f1f5f9",
                    }}
                  >
                    <img
                      src={
                        item.cover_url ||
                        ENDPOINT+"/assets/img/hacking.jpg"
                      }
                      alt={item.book_name}
                      style={{
                        maxHeight: "100%",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />
                    </div>

                  {/* Content */}
                  <div className="flex-grow-1">
                    <h4 className="h5 fw-bold mb-3 text-primary">
                      {item.book_name}
                    </h4>

                    {/* <p className="text-secondary mb-3">
                      {item.description || "No description available"}
                    </p> */}

                    {/* <div className="mb-2">
                      <small className="text-muted">
                        <strong>Batch ID:</strong> {item.batch_id}
                      </small>
                    </div> */}

                    <div className="mb-3">
                      <small className="text-muted">
                        <strong>Course:</strong>{" "}
                        <a
                          href={item.course_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary text-decoration-none"
                        >
                          View Course
                        </a>
                      </small>
                    </div>
                    </div>

                  {/* Action Button */}
                  <div className="mt-auto text-center">
                    <Link
                      to={`/book/${encodeURIComponent(item.book_name)}`}
                      className="btn btn-primary w-75"
                    >
                      View Details
                    </Link>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3 text-muted">Loading books...</p>
            </div>
          )}
</div>
      </div>
    </div>
  );
};

export default SingleBook;
